import React from 'react';
import { founderImage } from '../mock';
import { ArrowRight, Quote } from 'lucide-react';
import useReveal from '../hooks/useReveal';

export default function FounderSection() {
  const [ref, visible] = useReveal();
  return (
    <section id="story" ref={ref} style={{ scrollMarginTop: '100px' }} className={`max-w-7xl mx-auto px-3 sm:px-4 md:px-6 py-12 sm:py-14 md:py-24 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
      <div className="grid md:grid-cols-2 gap-8 md:gap-14 items-center">
        <div className="order-2 md:order-1">
          <div className="flex items-center gap-3 mb-4 sm:mb-5">
            <span className="h-px w-8 bg-[#C9A961]"></span>
            <span className="text-[10px] tracking-[0.4em] sm:tracking-[0.5em] uppercase text-[#8a6f2d]">A Personal Invitation</span>
          </div>
          <h2 className="font-serif-display text-2xl sm:text-3xl md:text-5xl leading-tight text-[#1A2332] mb-5 sm:mb-6">Curated by the Founder — worn with intent.</h2>
          <div className="relative pl-6 border-l-2 border-[#C9A961]/60 mb-6">
            <Quote className="absolute -left-3 -top-1 w-5 h-5 text-[#C9A961] fill-[#F5EFE6]" />
            <p className="font-serif-body italic text-lg md:text-xl text-[#1A2332]/80 leading-relaxed">
              “Fragrance is an unseen accessory. These are the scents I wear every day — each bottle a memory, each note a mood.”
            </p>
          </div>
          <p className="text-sm text-[#1A2332]/70 leading-relaxed mb-8 max-w-lg">
            Every Rajpurohit fragrance is composed in Grasse-inspired traditions and finished in India — high-concentration extraits meant to last through your longest days and warmest nights.
          </p>
          <a href="#collection" className="group inline-flex items-center gap-2 bg-[#1A2332] text-[#F5EFE6] px-6 py-3.5 text-[11px] tracking-[0.3em] uppercase hover:bg-[#2c3e5b] transition-colors">
            Explore The Reserve <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
        <div className="order-1 md:order-2 relative">
          <div className="absolute -inset-3 border border-[#C9A961]/30 rounded-lg -z-10"></div>
          <div className="rounded-lg overflow-hidden shadow-xl">
            {visible ? (
              <img src={founderImage} alt="Founder's Reserve" width={1200} height={800} loading="lazy" decoding="async" className="w-full h-[280px] sm:h-[380px] md:h-[540px] object-cover" />
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
}
